<template>
  <div class="issue-count">
    <div class="issue-count__circle"><span class="issue-count__number font-primary--bold">{{issueCount}}</span></div><span class="issue-count__supporting-text">Issues</span>
  </div>
</template>

<script>
  export default {
    name: 'issue-count',

    props: ['issues'],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{
      issueCount: function() {
        return this.issues.length || 0;
      }
    }
  }
</script>

<style lang="less" scoped>
@import "../../../less/base/project/_colors";
@import "../../../less/base/project/_variables";
.issue-count{

  .issue-count__supporting-text {
    display: inline-block;
    line-height: 4.4rem;
    margin-left: @spacing-unit/2;
  }

  .issue-count__circle {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    border: 0.2rem @brand--secondary-color solid;
    height: 4rem;
    width: 4rem;
    border-radius: 50%;
    color: @brand--secondary-color;

    .issue-count__number {
      position: absolute;
      display: block;
      top: -0.1rem;
      left: -0.1rem;
      width: 4rem;
      height: 4rem;
      line-height: 4rem;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// IssueCount.vue?2a1ba989